export class destroyController {
	constructor() {
		"ngInject";
	}

	$onClose() {
		this.close({$value: "cancel"});
	}

	$onConfirm() {
		this.close({$value: "confirm"});
	}

	$getType() {
		return (this.resolve.type || "confirm").toUpperCase();
	}

}


// WEBPACK FOOTER //
// ./sources/utility/confirm/confirm.controller.js